/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerMundialComponent from "../components/multi_cotizacion/banner-mundial.component";
import VideoMundialComponent from "../components/multi_cotizacion/video-mundial.component";
import ComoParticiparComponent from "../components/multi_cotizacion/como-participar.component";
import TerminosMundialComponent from "../components/multi_cotizacion/terminos-mundial.component";
import MenuMundialComponent from "../components/multi_cotizacion/menu-mundial.component";
import BannerComponent from "../components/multi_cotizacion/banner.component";
import { getResponsiveImage, buildCmsUrl } from "../utils/imageHelper";


import {
  multicotizador,
  vehiclesSimulator,
} from "../components/conexion/vehicles.conexion";
import "../assets/css/mundial-page-bg.css";
import "../assets/css/cotizador-mundial-override.css";
import VehiculosMundialComponent from "../components/multi_cotizacion/vehiculos_mundial.component";
import CotizacionVehiculosMundialComponent from "../components/multi_cotizacion/cotizacion-vehiculos-mundial.component";

const splitToBalancedLines = (text: string) => {
  if (!text || typeof text !== 'string') return text;
  
  // Limpiamos la frase de espacios dobles o espacios irrompibles (NBSP) que suelen venir de los CMS
  const normalizedText = text.replace(/[\s\u00A0]+/g, ' ').trim();
  const words = normalizedText.split(' ');
  
  if (words.length <= 1) return normalizedText;

  // Calculamos cuantas líneas serían óptimas asumiendo entre 18-20 caracteres por línea.
  const numLines = Math.max(1, Math.ceil(normalizedText.length / 20));
  
  if (numLines === 1) return normalizedText;

  const targetLength = normalizedText.length / numLines;
  const lines: string[] = [];
  
  let currentLine = '';
  
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const wouldBeLength = currentLine.length + word.length;
    
    if (wouldBeLength >= targetLength && currentLine.length > 0) {
      const diffWith = Math.abs(targetLength - wouldBeLength);
      const diffWithout = Math.abs(targetLength - currentLine.length);
      
      if (lines.length < numLines - 1 && diffWithout < diffWith) {
        lines.push(currentLine.trim());
        currentLine = word + ' ';
      } else {
        currentLine += word + ' ';
      }
    } else {
      currentLine += word + ' ';
    }
  }
  
  if (currentLine.trim()) {
    lines.push(currentLine.trim());
  }

  return (
    <>
      {lines.map((line, idx) => (
        <span key={idx} style={{ display: "block", width: "100%", textAlign: "left" }}>
          {line}
        </span>
      ))}
    </>
  );
};

const MultiCotizacionMundialPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [vehiculosData, setVehiculosData]: any = useState([]);
  const [vehiculosSelected, setVehiculosSelected]: any = useState(null);
  const [multicotizadorData, setMulticotizadorData]: any = useState([]);
  const [worldCupData, setWorldCupData]: any = useState(null);

  const [isScrolled, setIsScrolled] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);




  useEffect(() => {
    setIsPortrait(window.innerHeight > window.innerWidth);
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const slugToVehicleName: Record<string, string> = {
      "creta": "CRETA",
      "grand-i10": "Grand i10",
      "grand-metro-taxi-hatchback": "GRAND METRO HATCHBACK",
      "grand-metro-taxi-sedan": "GRAND METRO SEDÁN",
      "hb20-hatchback": "HB20 Hatchback",
      "hb20s-sedan": "HB20S Sedán",
      "ioniq-5": "IONIQ 5",
      "kona-electrica": "KONA Eléctrica",
      "kona-gasolina": "KONA Gasolina",
      "kona-hibrida": "KONA Híbrida",
      "kona-n-line": "KONA Híbrida N Line",
      "palisade": "PALISADE",
      "santa-fe-hibrida": "SANTA FE Híbrida",
      "staria-lujo": "STARIA lujo",
      "staria-panel": "STARIA panel",
      "staria-pasajeros": "STARIA pasajeros",
      "tucson": "TUCSON Gasolina",
      "tucson-hibrida": "TUCSON Híbrida",
      "venue": "VENUE"
    };

    const urlParams = new URLSearchParams(window.location.search);
    let selectedSlug = urlParams.get("vehiculo");

    if (!selectedSlug) {
      const hash = window.location.hash.replace("#", "");
      if (hash && slugToVehicleName[hash]) {
        selectedSlug = hash;
      }
    }

    const targetVehicleName = selectedSlug ? slugToVehicleName[selectedSlug] : null;

    vehiclesSimulator().then(function (res: any) {
      let data: any = res?.data?.data;

      if (data) {
        const allowedVehicles = [
          "TUCSON Híbrida",
          "TUCSON Gasolina",
          "Grand i10",
          "SANTA FE Híbrida",
          "VENUE",
          "KONA Híbrida",
          "KONA Híbrida N Line",
          "KONA Gasolina",
          "KONA Eléctrica"
        ];

        if (targetVehicleName && !allowedVehicles.includes(targetVehicleName)) {
          allowedVehicles.push(targetVehicleName);
        }

        data = data.filter((v: any) => allowedVehicles.includes(v.name));
        data.sort((a: any, b: any) => allowedVehicles.indexOf(a.name) - allowedVehicles.indexOf(b.name));
      }

      setVehiculosData(data);
      if (data && data.length > 0) {
        if (targetVehicleName) {
          const found = data.find((v: any) => v.name === targetVehicleName);
          setVehiculosSelected(found || data[0]);

          setTimeout(() => {
            const scheduleButtonAnchor = worldCupData?.schedule_button_url_anchor?.replace("#", "") || "cotizador";
            const element = document.getElementById(scheduleButtonAnchor);
            if (element) {
              const offsetTop = element.offsetTop - 120;
              window.scrollTo({
                top: offsetTop,
                behavior: "smooth",
              });
            }
          }, 500);
        } else {
          setVehiculosSelected(data[0]);
        }
      }
    });

    multicotizador().then(function (res: any) {
      setMulticotizadorData(res?.data?.data);
    });

    fetch('https://gateway.hyundaicolombia.co/world-cup')
      .then(res => res.json())
      .then(data => {
        if (data?.data?.[0]) {
          setWorldCupData(data.data[0]);
        }
      })
      .catch(err => console.error('Error fetching world cup data:', err));
  }, [worldCupData?.schedule_button_url_anchor]);

  if (!worldCupData) {
    return <div>Cargando...</div>;
  }

  const bannerTitleFirstLine = worldCupData.banner_title.split(' de la Copa Mundial de la FIFA 2026™')[0];
  const bannerTitleSecondLine = "de la Copa Mundial";
  const bannerTitleThirdLine = "de la FIFA 2026™";

  const bannerImageUrl = worldCupData.banner_media ? buildCmsUrl(worldCupData.banner_media.url) : "";


  return (
    <>
      <div
        style={{
          transition: "transform 0.4s ease-in-out, opacity 0.4s ease-in-out",
          transform: isScrolled ? "translateY(-100%)" : "translateY(0%)",
          opacity: isScrolled ? 0 : 1,
          pointerEvents: isScrolled ? "none" : "auto",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1000
        }}
      >
        <MenuLayouts
          className="home-page"
          active="somos"
          setVisibleHeight={setVisibleHeight}
          visibleHeight={visibleHeight}
        />
      </div>
      <div className="home-page mundial-page-parallax-bg">
        <h1 style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}>
          {worldCupData.banner_title}
        </h1>

        <div className="home-page-mascara"></div>
        
        <MenuMundialComponent 
          visibleHeight={visibleHeight} 
          topButtons={worldCupData.top_buttons}
        />
        
        <BannerComponent 
          multicotizadorData={multicotizadorData} 
          customImage={bannerImageUrl}
        >
          <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", marginTop: isPortrait ? "80px" : "0px", height: "100%", display: "flex", alignItems: "flex-start", padding: "0 10px" }}>
              <div className="mundial-hero-left" style={{ pointerEvents: "auto", marginTop: isPortrait ? "0px" : "120px" }}>
                <h1 className="mundial-hero-title" style={{ marginBottom: 0, textAlign: "left", width: "100%" }}>
                  {splitToBalancedLines(worldCupData.banner_title)}
                </h1>
              </div>
            </div>
          </div>
        </BannerComponent>
        
        <VideoMundialComponent 
          intro_title={worldCupData.intro_title}
          intro_video_link={worldCupData.intro_video_link}
          show_intro_video={worldCupData.show_intro_video}
        />
        <BannerMundialComponent 
          multicotizadorData={multicotizadorData} 
          worldCupData={worldCupData}
        />
        <ComoParticiparComponent worldCupData={worldCupData} />

        <div className="cotizacion-multiple-component sin-background" id={worldCupData.schedule_button_url_anchor?.replace("#", "")}>
          <div className="mundial-cotizador-header">
            <h2>{worldCupData.schedule_title}</h2>
            <p>{worldCupData.schedule_subtitle}</p>
          </div>

          <VehiculosMundialComponent
            vehiculosData={vehiculosData}
            setVehiculosSelected={setVehiculosSelected}
            vehiculosSelected={vehiculosSelected}
          />
          {vehiculosSelected !== null ? (
            <CotizacionVehiculosMundialComponent vehiculo={vehiculosSelected} />
          ) : null}
        </div>
        
        <TerminosMundialComponent worldCupData={worldCupData} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default MultiCotizacionMundialPage;